<div class="grid grid-cols-12 gap-2 p-2">
  <!-- isAuthenticated: {{ isAuthenticated }} -->

  @if (isAuthenticated) { @if(isConfigurazione){
  <div class="col-span-12">
    <p-menubar [model]="menuItems" />
  </div>
  }
  <div class="col-span-12">
    <p-panel header="{{ 'emed-main-dispatcher.UTENTE' | translate }}">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-4 md:col-span-4 lg:col-span-2">
          <h3>
            Benvenuto <span class="font-bold">{{ idToken.email }}</span>
          </h3>
        </div>
      </div>
    </p-panel>
  </div>
  }

  <div class="col-span-12">
    <router-outlet></router-outlet>
  </div>
</div>
